import GameProvider from './game/b.providers/GameProvider/GameProvider'
import React, { useEffect } from 'react'
import Game from './Game'
import { enableMapSet } from 'immer'
import { useFonts } from 'expo-font'
import { useCssImporter } from './game/utils/react'
import 'animate.css'

enableMapSet()

const CssPathsToImport = [
  `${process.env.PUBLIC_URL}/assets/styles/index.css`,
  `${process.env.PUBLIC_URL}/assets/styles/window.css`,
  `${process.env.PUBLIC_URL}/assets/styles/team-selection.css`,
  `${process.env.PUBLIC_URL}/assets/styles/landing.css`,
  `${process.env.PUBLIC_URL}/assets/styles/slider.css`,
]

const App = () => {
  const [loaded, error] = useFonts({
    EraserRegular: `${process.env.PUBLIC_URL}/assets/fonts/EraserRegular.ttf`,
    MonsterPumpkin: `${process.env.PUBLIC_URL}/assets/fonts/MonsterPumpkin-MVBzP.ttf`,
    WitcherKnight: `${process.env.PUBLIC_URL}/assets/fonts/WitcherKnight-vmLdA.ttf`,
    HellghostRough: `${process.env.PUBLIC_URL}/assets/fonts/HellghostRoughRegular-8MK9A.ttf`,
  })
  useCssImporter(CssPathsToImport)
  useEffect(addAnalytics, [])
  return (
    <GameProvider>
      {(loaded || error !== null) && (
        <>
          <Game />
        </>
      )}
    </GameProvider>
  )
}

export default App

const addAnalytics = () => {
  const s = document.createElement('script')
  s.async = true
  s.src = 'https://www.googletagmanager.com/gtag/js?id=G-KVXFDTR5E2'
  window.document.head.appendChild(s)
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  function gtag() {
    // @ts-ignore
    dataLayer.push(arguments)
  }
  // @ts-ignore
  gtag('js', new Date())
  // @ts-ignore
  gtag('config', 'G-KVXFDTR5E2')
}
